<template>
	<div class="body-container" id="h-box">
		<Header :headerMini="headerMini" v-if="!headerMini"></Header>
		<div class="main-box">
			<div class="page-header-options">
				<div class="page-header-breadcrumb">
					<div class="breadcrumb-nav breadcrumb-nav-composed">
						<ul class="nav-links">
							<li class="nav-link" @click="goHome">
								<a ><span class="iconfont icon-shouye"></span></a>
							</li>
							<li class="nav-link">
								<span class="iconfont icon-xiangyou1"></span>
							</li>
							<li class="nav-link">
								<span>Newsroom</span>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="page-header  no-bg-img page-title-large headline-module__wrapper" style="">
				<div class="page-wrapper">
					<div class="content">
						<h1 class="page-title">Global Newsroom</h1>
					</div>
				</div>
			</div>
			<div class="news-top-section">
				<div data-module-id="overviewModule" class="csr-module js-overview-expand global-module">
					<div data-scroll-up="true" class="csr-committee overview-full description js-overview-full" v-if="showContacts">
						<div
							class="contact-module csr-contacts-hidden js-contact-module contact-module-default-bg contact-module-center">
							<div class="button-expanded-wrapper csr page-wrapper">
								<div class="firm-row">
									<ul class="main-contacts">
										<li class="contact-information" v-for="(item,index) in contactsLists">
											<div class="professional-tile not-linked">
												<div class="content">
													<div class="profile-image">
														<img :src="item.img">
													</div>
													<div class="profile">
														<h3 class="name">{{item.name}}</h3>
														<div class="title">{{item.remarks}}</div>
														<div class="bottom">
															<div class="contact">
																<span class="phone"><span class="iconfont icon-dianhua"></span>{{item.phone}}</span>
																<span href="#" class="contact-link-url email"> <span class="iconfont icon-email"></span>Email</span>
															</div>
														</div>
													</div>
												</div>
											</div>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<div class="csr-trigger csr-trigger-more">
						<div class="button-red button-medium csr-button-expand js-overview-trigger button-expand"@click="changeContacts">
							Media Contacts <span class="iconfont icon-xiangshang" v-if="showContacts"></span><span class="iconfont icon-xiangxia" v-else></span>
						</div>
					</div>
				</div>
				<!-- ko if: HasSearchRun() == false -->
				<div class="global-module-page-wrapper global-module">

					<div class="featured-insights global-module">
						<div class="global-module-wrapper">
							<div class="featured-insights__collection ">
								<div class="featured-insights__tile promo-content-tile  ">
									<a class="promo-content-link">
										<div class="container-table">
											<div class="container-row ">
												<div class="h-bg"></div>
												<div class="content">
													<div class="content-meta-header">
														<div class="content-type-label ">

															News | Deal Announcement
														</div>

													</div>

													<div class="content-headline">Baker McKenzie Advises on World's
														First Cross-Border Repo and Natively-Issued Digital Bond Pilot
													</div>
													<div class="content-summary">The transaction was part of Project
														Guardian by the Monetary Authority of Singapore, a collaborative
														initiative with the financial industry.</div>
												</div>
											</div>
										</div>
									</a>
								</div>

								<div class="featured-insights__tile promo-content-tile  ">
									<a class="promo-content-link">
										<div class="container-table">
											<div class="container-row ">
												<div class="h-bg"></div>
												<div class="content">
													<div class="content-meta-header">
														<div class="content-type-label ">
															News | Firm News
														</div>

													</div>

													<div class="content-headline">Baker McKenzie Announces Global
														Revenues of USD $3.3 Billion</div>
													<div class="content-summary">Our revenues of USD $3.3 billion for
														the fiscal year ended 30 June 2023 are up 2.5% on a currency
														neutral basis. &nbsp;</div>
												</div>
											</div>
										</div>

									</a>

								</div>
								<div class="featured-insights__tile promo-content-tile  ">
									<a class="promo-content-link">
										<div class="container-table">
											<div class="container-row ">
												<div class="h-bg"></div>
												<div class="content">
													<div class="content-meta-header">
														<div class="content-type-label ">

															News | Firm News
														</div>

													</div>

													<div class="content-headline">Baker McKenzie Strengthens Its Private
														Equity Team with Veteran Partner Eric Schwartzman</div>
													<div class="content-summary">Firm Continues to Expand Its
														Transactional Group in Northern California</div>
												</div>
											</div>
										</div>
									</a>
								</div>
								<template v-if="newsShowMore">
									<div class="featured-insights__tile promo-content-tile  ">
										<a class="promo-content-link">
											<div class="container-table">
												<div class="container-row ">
													<div class="h-bg"></div>
													<div class="content">
														<div class="content-meta-header">
															<div class="content-type-label ">
																News | Firm News
															</div>
									
														</div>
									
														<div class="content-headline">Baker McKenzie Announces Global
															Revenues of USD $3.3 Billion</div>
														<div class="content-summary">Our revenues of USD $3.3 billion for
															the fiscal year ended 30 June 2023 are up 2.5% on a currency
															neutral basis. &nbsp;</div>
													</div>
												</div>
											</div>
									
										</a>
									
									</div>
									<div class="featured-insights__tile promo-content-tile  ">
										<a class="promo-content-link">
											<div class="container-table">
												<div class="container-row ">
													<div class="h-bg"></div>
													<div class="content">
														<div class="content-meta-header">
															<div class="content-type-label ">
																News | Firm News
															</div>
									
														</div>
									
														<div class="content-headline">Baker McKenzie Announces Global
															Revenues of USD $3.3 Billion</div>
														<div class="content-summary">Our revenues of USD $3.3 billion for
															the fiscal year ended 30 June 2023 are up 2.5% on a currency
															neutral basis. &nbsp;</div>
													</div>
												</div>
											</div>
									
										</a>
									
									</div>
									<div class="featured-insights__tile promo-content-tile  ">
										<a class="promo-content-link">
											<div class="container-table">
												<div class="container-row ">
													<div class="h-bg"></div>
													<div class="content">
														<div class="content-meta-header">
															<div class="content-type-label ">
																News | Firm News
															</div>
									
														</div>
									
														<div class="content-headline">Baker McKenzie Announces Global
															Revenues of USD $3.3 Billion</div>
														<div class="content-summary">Our revenues of USD $3.3 billion for
															the fiscal year ended 30 June 2023 are up 2.5% on a currency
															neutral basis. &nbsp;</div>
													</div>
												</div>
											</div>
									
										</a>
									
									</div>
								</template>
							</div>
						</div>
					</div>

				</div>
				<!-- /ko -->
			</div>
			<div class="news-more-block">
				<div class="news-more-btn" @click="showMoreNews">SEE MORE NEWS <span class="iconfont icon-xiangshang" v-if="showContacts"></span><span class="iconfont icon-xiangxia" v-else></span></div>
			</div>
		</div>
		
		<div class="social-footer">
		    <h2 class="social-footer-title">Connect with Baker McKenzie</h2>
		    <div class="communication-footer">
		        <ul class="social-links">
		            <li class="social-link">
		                <a class="bm bm-linkedin" href="#0"><span class="iconfont icon-tuite"></span></a>
		            </li>
		            <li class="social-link">
		                <a class="iconfont icon-f" target="_blank"></a>
		            </li>
		            <li class="social-link"><a class="iconfont icon-weibiaoti1"target="_blank"></a></li>
		            <li class="social-link"><a class="iconfont icon-weixin"target="_blank"></a></li>
		            <li class="social-link"><a class="iconfont icon-wifi"target="_blank"></a></li>
		        </ul>
		        <div>
		            <div class="button-red button-medium">
		                        RSS News Feeds
		                    </div>
		        </div>
		    </div>
		</div>
		<div class="global-footer">
		    <div class="footer-nav hide-print">
		            <ul class="utility-links">
		                        <li class="utility-link"><a>Disclaimers</a></li>
		                        <li class="utility-link"><a>Privacy &amp; Cookies Statement</a></li>
		                        <li class="utility-link"><a class="ot-sdk-show-settings" title="Manage Choices">Cookie Preferences</a></li>
		                        <li class="utility-link"><a>CCPA Privacy Disclosures</a></li>
		                        <li class="utility-link"><a>Contact Us</a></li>
		                        <li class="utility-link"><a>Media Contacts</a></li>
		                        <li class="utility-link"><a>Blogs</a></li>
		                        <li class="utility-link"><a>BM Online</a></li>
		            </ul>
		        
		    </div>
		    <div class="copyright">
		<p><span>Attorney Advertising | © 2024 Baker McKenzie</span></p>    </div>
		</div>
	</div>
</template>

<script>
	import Header from '../../components/header.vue'
	export default {
		components: {
			Header
		},
		data() {
			return {
				headerMini: false,
				thresholdHeight: 100,
				showContacts:false,
				contactsLists:[{
					name:'Patricia Lojo',
					img:require('../../assets/test/22.webp'),
					remarks:'Associate Director, Media Relations, North America',
					phone:'+ 1 212 626 4363',
					email:'w.com'
				},{
					name:'Gareth Cater',
					img:require('../../assets/test/23.jpeg'),
					remarks:'Senior Manager, Global Media Relations',
					phone:'+ 1 212 626 4363',
					email:'w.com'
				},{
					name:'Maïté Oreglia',
					img:require('../../assets/test/24.webp'),
					remarks:'EMEA Media Relations Lead',
					phone:'+ 32 3 303 25 08',
					email:'w.com'
				},{
					name:'Sasha Mirpuri',
					img:require('../../assets/test/25.webp'),
					remarks:'Manager, Communications, Latin America',
					phone:'+ 51 1 618 8537',
					email:'w.com'
				},{
					name:'Jamie Kar',
					img:require('../../assets/test/26.webp'),
					remarks:'Senior Communications Manager, Asia Pacific',
					phone:'+ 852 2846 1759',
					email:'w.com'
				},{
					name:'Estefania Herlein',
					img:require('../../assets/test/27.jpeg'),
					remarks:'Media Relations Specialist, Buenos Aires',
					phone:'+ 54 11 6065 7777',
					email:'w.com'
				},{
					name:'Melissa Chia',
					img:require('../../assets/test/28.webp'),
					remarks:'Communications Manager, Singapore',
					phone:'+ 65 6434 2537',
					email:'w.com'
				},{
					name:'Jeremy Hyman',
					img:require('../../assets/test/29.webp'),
					remarks:'Head of Communications, Australia',
					phone:'+ 61 2 8922 5448',
					email:'w.com'
				}],
				newsShowMore:false
			}
		},
		mounted() {
			window.addEventListener('scroll', this.checkScrollPosition);
		},
		beforeDestroy() {
			// 在组件销毁前移除滚动监听
			window.removeEventListener('scroll', this.checkScrollPosition);
		},
		methods: {
			checkScrollPosition() {
				this.headerMini = window.scrollY >= this.thresholdHeight;
			},
			changeContacts(){
				this.showContacts = !this.showContacts
			},
			showMoreNews(){
				this.newsShowMore = true
			},
			goHome(){
				this.$router.replace('/'); 
			}
		}
	}
</script>

<style lang='scss' scoped>
	.body-container {
		width: 100%;
		/* min-width: 1280px; */
		min-height: 100vh;
		overflow: hidden;
		position: relative;
		background-color: #fff;
	}

	.main-box {
		width: 100%;
		padding-top: 82px;
		overflow: hidden;
	}

	.page-header-options {
		background: linear-gradient(287.72deg, #ad122a -2.45%, #790123 185.33%);
		padding: 0.375em 0;
		text-align: right;

		.page-header-breadcrumb {
			padding-right: 1.5em;
			padding-left: 1.5em;
			margin-left: auto;
			margin-right: auto;

			.breadcrumb-nav {
				float: left;
				text-align: left;
				padding: 0;

				.nav-links {
					padding: 0;
					margin: 0;
					list-style-type: none;
					white-space: nowrap;
					overflow: hidden;
					display: block;
					text-overflow: ellipsis;
					
					.icon-shouye {
						color: #fff;
						font-size: 15px;
						cursor: pointer;
					}
					
					.icon-xiangyou1 {
						font-size: 13px;
						margin: 0 5px;
					}

					.nav-link {
						display: inline;
						color: #FFF;
						font-family: "BakerMcKenzieBernini", Arial Narrow, Arial;
						font-weight: normal;
						font-style: normal;
						font-size: 0.875em;
						letter-spacing: 1px;
					}

					.nav-link:first-of-type a {
						font-size: 0;
					}

					.breadcrumb-nav .nav-link a {
						color: inherit;
					}
				}
			}
		}
	}

	.page-header {
		padding: 4.375em 0;
		background-size: cover;
		border-bottom: 1px solid #cececd;
	}

	.page-header.page-title-large {
		padding: 3.75em 0;
	}

	.headline-module__wrapper {
		background: linear-gradient(287.72deg, #ad122a -2.45%, #790123 185.33%);
	}

	.page-wrapper {
		max-width: 79.875em;
		padding-right: 1.5em;
		padding-left: 1.5em;
		margin-left: auto;
		margin-right: auto;
	}

	.page-header .page-title {
		font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
		font-weight: normal;
		font-style: normal;
		font-weight: bold;
		line-height: 1;
		color: #FFF;
		font-size: 2.25em;
		text-align: center;
		margin-bottom: 0.5em;
	}

	.page-header.page-title-large .page-title {
		font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
		font-weight: normal;
		font-style: normal;
		font-weight: bold;
		line-height: 1;
		color: #FFF;
		font-size: 4.5em;
	}
	.news-top-section {
	    padding: 1.25em 0;
		
		.global-module {
		    padding-top: 3.75em;
		    padding-bottom: 3.75em;
		    background: none;
			
			
			.csr-module .csr-committee .contact-module {
			    padding: 0;
			}
			.page-wrapper {
			    max-width: 79.875em;
			    padding-right: 1.5em;
			    padding-left: 1.5em;
			    margin-left: auto;
			    margin-right: auto;
				
				.firm-row {
				    border-top: 1px solid #cececd;
				}
				.firm-row:first-of-type {
				    border-top: none;
				}
			}
			.contact-module ul {
			    list-style-type: none;
			}
			.contact-module .main-contacts {
			    margin-top: 1.875em;
			    display: -ms-flexbox;
			    display: flex;
			    -ms-flex-wrap: wrap;
			    flex-wrap: wrap;
			}
			.contact-module.contact-module-center .main-contacts {
			    -ms-flex-pack: center;
			    justify-content: center;
			}
			.contact-module .contact-information {
			    margin-bottom: 2.8125em;
				width: 22.515%;
			    float: left;
			    margin-right: 2.1275%;
			    position: relative;
			    display: -ms-flexbox;
			    display: flex;
			    -ms-flex-direction: column;
			    flex-direction: column;
			}
			.professional-tile {
			    padding: 1em;
			    background-color: #FDFDFD;
			    position: relative;
			    min-height: 20.3125em;
			    display: block;
			    border: 1px solid #D2D2D2;
			}
			.professional-tile:after {
			    content: "";
			    position: absolute;
			    top: 0;
			    left: 0;
			    width: 100%;
			    height: 3px;
			    background-color: #ad122a;
			    transition: height 0.4s ease-in-out;
			}
			.professional-tile.not-linked {
			    cursor: text;
			}
			.csr-module .csr-committee .contact-module .professional-tile {
			    margin-top: 0;
			}
			.professional-tile .profile-image {
			    background-color: transparent;
			    display: inline-block;
			    border-radius: 3px;
			    position: relative;
			    z-index: 2;
			}
			.professional-tile .profile-image img {
			    width: 5.1875em;
			    display: block;
			}
			.professional-tile .name {
			    font-size: 1.5em;
			    line-height: 1;
			    margin-top: 0.28571em;
			    font-weight: bold;
			    color: #ad122a;
			    margin-bottom: 0.3125em;
			    position: relative;
			}
			.professional-tile.not-linked .name {
			    color: #323232;
			}
			.professional-tile .title {
			    font-size: 18px;
			    position: relative;
				letter-spacing: 2px;
			}
			.professional-tile .title, .professional-tile .locations {
			    color: #323232;
			    position: relative;
			}
			.professional-tile .bottom {
			    font-size: 14px;
			    position: absolute;
			    bottom: 0;
			    left: 0;
			    width: 100%;
			    color: #323232;
			}
			.professional-tile .contact {
			    font-weight: 500;
			    margin-top: 1.14286em;
			    padding: 1.14286em;
			    position: relative;
			}
			.professional-tile .phone {
			    cursor: pointer;
			    margin-right: 1.25em;
			    color: #ad122a;
				font-size: 14px;
				font-weight: bold;
				letter-spacing: 1px;
			}
			.professional-tile .contact :not(:last-child) {
			    margin-right: 1.25rem;
			}
			.professional-tile .email {
			    cursor: pointer;
			    color: #ad122a;
			    white-space: nowrap;
			}
			.icon-dianhua {
				font-size: 13px;
				margin-right: 5px;
			}
			.icon-email {
				font-size: 15px;
				margin-right: 5px;
			}
			.button-red, #close-video {
			    text-transform: uppercase;
			    transition: background-color 0.4s;
			    color: #FFF;
			    padding: 1em 2em;
			    background-color: #ad122a;
			    line-height: 1em;
			    display: inline-block;
			    font-family: "BakerMcKenzieBernini", Arial Narrow, Arial;
			    font-weight: normal;
			    font-style: normal;
			    font-weight: bold;
			}
			.button-medium {
			    padding-left: 4em;
			    padding-right: 4em;
			}
			.csr-module .csr-trigger .csr-button-expand {
			    display: block;
			    margin: 0 auto 0 auto !important;
			}
			.button-red:hover {
			    background-color: #780123;
				cursor: pointer;
			}
			.csr-trigger-more {
				display: flex;
				justify-content: center;
				
				.icon-xiangxia {
					font-size: 13px;
					margin: 0 0 0 5px;
				}
			}
		}
		.featured-insights.global-module {
		    padding-top: 0;
		    padding-bottom: 0;
			
			.global-module-wrapper {
			    padding-left: 0;
			    padding-right: 0;
			    width: 100%;
				max-width: 79.875em;
				margin-left: auto;
				margin-right: auto;
				
				.featured-insights__collection {
				    display: -ms-flexbox;
				    display: flex;
				    -ms-flex-wrap: wrap;
				    flex-wrap: wrap;
					justify-content: center;
					
					.featured-insights__tile {
					    width: 26.75%;
					    margin-right: 3%;
					    margin-bottom: 30px;
					}
					.promo-content-tile {
					    position: relative;
					    background-color: #FFF;
						
						.promo-content-link {
						    display: block;
						    height: 100%;
						}
						.container-table {
						    position: relative;
						    width: 100%;
						    height: calc(100% - 50px);
						    margin-bottom: 50px;
						    background-color: #FFF;
						}
						.container-row {
						    background-color: #FFF;
						    padding: 30px 20px;
						    border: 1px solid #D2D2D2;
						    height: 100%;
						    min-height: 300px;
							position: relative;
						}
						.promo-content-link .container-row {
						    display: -ms-flexbox;
						    display: flex;
						}
						.content {
						    display: -ms-flexbox;
						    display: flex;
						    -ms-flex-wrap: wrap;
						    flex-wrap: wrap;
						    position: relative;
						    overflow: hidden;
						    vertical-align: middle;
						    width: 100%;
						    z-index: 1;
							
							.content-meta-header, .content-type-label {
							    font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
							    font-weight: normal;
							    font-style: normal;
							    color: #646464;
							    margin-bottom: 0.9375em;
								display: flex;
							}
						}
					}
					.promo-content-tile .promo-content-link .content-type-label, .promo-content-tile .promo-content-link .content-meta-header, .promo-content-tile .promo-content-link .content-headline {
					    transition: color .3s ease-in-out;
					    width: 100%;
					}
					.promo-content-tile .content-headline {
					    font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
					    font-weight: normal;
					    font-style: normal;
					    font-weight: bold;
					    line-height: 1;
					    font-size: 1.5em;
					    color: #323232;
					    word-wrap: break-word;
					    max-width: 333px;
					    line-height: 1.25;
						letter-spacing: 1px;
					}
					.promo-content-tile .content .content-meta-header .content-type-label {
					    margin-bottom: 0;
					    width: 100%;
					}
					.promo-content-tile .content-summary {
					    font-size: 18px;
					    color: #323232;
					    line-height: 1.5;
					    margin-top: 1.5em;
					    display: block;
					    transition: color .3s ease-in-out;
						letter-spacing: 1px;
					}
					.promo-content-tile .container-row:after {
					    content: "";
					    position: absolute;
					    top: 0;
					    left: 0;
					    width: 100%;
					    height: 3px;
					    background-color: #ad122a;
					    transition: height 0.4s ease-in-out;
					}
					.container-row:hover{
						
						.h-bg {
							width: 100%;
							height: 100%;
							background-color: #ad122a;
							overflow: hidden;
							position: absolute;
							top: 0;
							animation: example1 0.8s ;
							left: 0;
						}
						.content-headline,.content-type-label,.content-summary {
							color: #fff;
						}
						
						@keyframes example1 {
							from {
								height: 0;
							}
							
							to {
								height: 100%;
								/* 或者你想要的任何长度 */
							}
						}
					}
				}
			}
		}
		a {
		    color: #ad122a;
		    transition: color 0.4s, background-color 0.4s;
		}
	}
	.csr-module .csr-trigger {
	    padding: 2em 0 2em 0;
	}
	.news-top-section .csr-trigger {
	    padding-bottom: 0;
	}
	.news-more-block {
		width: 100%;
		margin: 2em auto 5.625em;
		display: flex;
		justify-content: center;
		
		.news-more-btn {
			float: left;
			display: block;
			margin: 0 auto;
			padding: 1em 2em;
			background-color: #ad122a;
			color: #FFF;
			line-height: 1em;
			font-weight: bold;
			font-size: 16px;
			letter-spacing: 1px;
		}
		.news-more-btn:hover {
		    background-color: #780123;
			cursor: pointer;
		}
	}
	.social-footer {
	    margin: 0;
	    position: relative;
	    text-align: center;
		
		.social-footer-title {
		    text-align: center;
			margin: 0;
		}
		h2, .h2 {
		    font-size: 32px;
		}
		.communication-footer {
		    text-align: center;
		}
		.communication-footer .social-links {
		    display: inline-block;
		}
		li {
		    display: inline-block;
		    margin: 0.5em;
		    position: relative;
		    cursor: pointer;
		}
		.communication-footer .social-link {
		    display: inline-block;
		    margin-left: 1rem;
		    margin-right: 1rem;
		    vertical-align: middle;
		    font-size: 1.75em;
		}
		.social-link a {
		    color: #ad122a;
		}
		.social-link .iconfont {
			font-size: 32px;
		}
		.bm, .promo-content-tile .content .external-link-icon:before {
		    display: inline-block;
		    font-family: "bakermckenzie";
		    font-style: normal;
		    font-weight: normal;
		    font-variant: normal;
		    font-size: inherit;
		    speak: none;
		    line-height: 1;
		    text-transform: none !important;
		    -webkit-font-smoothing: antialiased;
		    -moz-osx-font-smoothing: grayscale;
		    vertical-align: -6.14286%;
		}
		li {
		    display: inline-block;
		    margin: 0.5em;
		    position: relative;
		    cursor: pointer;
		}
		.button-red {
		    margin: 1.875em auto 1.875em;
			letter-spacing: 1px;
		}
		.button-medium {
		    padding-left: 4em;
		    padding-right: 4em;
		}
		.button-red, #close-video {
		    text-transform: uppercase;
		    transition: background-color 0.4s;
		    color: #FFF;
		    padding: 1em 2em;
		    background-color: #ad122a;
		    line-height: 1em;
		    display: inline-block;
		    font-family: "BakerMcKenzieBernini", Arial Narrow, Arial;
		    font-weight: normal;
		    font-style: normal;
		    font-weight: bold;
		}
	}
	.global-footer, .global-footer-social {
	    font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
	    font-weight: normal;
	    font-style: normal;
	    background: linear-gradient(108.99deg, #ad122a -0.16%, #790123 153.62%);
	    padding-top: 4.375em;
	    padding-bottom: 3.125em;
	}
	.global-footer .footer-nav, .global-footer-social .footer-nav {
	    border-top: 1px solid #cececd;
	    max-width: 79.875em;
	    padding-right: 1.5em;
	    padding-left: 1.5em;
	    margin-left: auto;
	    margin-right: auto;
	    padding: 1.5em 0 0;
	}
	.global-footer .utility-links, .global-footer-social .utility-links {
	    display: -ms-flexbox;
	    display: flex;
	    -ms-flex-pack: justify;
	    justify-content: space-between;
	}
	.font-size-body-copy, .global-footer .utility-links, .global-footer-social .utility-links, .social-share-section span {
	    font-size: 1.125em;
	}
	.utility-links {
	    text-align: center;
	}
	.global-footer .utility-link, .global-footer-social .utility-link {
	    color: #FFF;
	}
	.utility-links .utility-link {
	    display: inline-block;
	    padding-right: 1em;
	}
	.global-footer .utility-link a, .global-footer-social .utility-link a {
	    color: #FFF;
	}
	.global-footer .copyright, .global-footer-social .copyright {
	    margin-top: 1.5em;
	    color: #FFF;
	    max-width: 79.875em;
	    padding-right: 1.5em;
	    padding-left: 1.5em;
	    margin-left: auto;
	    margin-right: auto;
	    padding: 0;
		text-align: center;
	}
	.global-footer .footer-nav, .global-footer .copyright, .global-footer-social .footer-nav, .global-footer-social .copyright {
	    margin-left: 1.5em;
	    margin-right: 1.5em;
	}
	@media screen and (max-width: 47.9375em){
		.featured-insights__tile {
		    width: 100% !important;
		    margin-right: 0;
		    padding: 0 10px;
		}
		.global-footer .footer-nav, .global-footer .copyright, .global-footer-social .footer-nav, .global-footer-social .copyright {
		    margin-left: 1.5em;
		    margin-right: 1.5em;
		}
		.global-footer .footer-nav .utility-links, .global-footer-social .footer-nav .utility-links {
		    display: -ms-flexbox;
		    display: flex;
		    -ms-flex-direction: row;
		    flex-direction: row;
		    -ms-flex-wrap: wrap;
		    flex-wrap: wrap;
		    text-align: left;
		    padding: 0;
		    -ms-flex-align: center;
		    align-items: center;
		}
		.global-footer .footer-nav .utility-links .utility-link, .global-footer-social .footer-nav .utility-links .utility-link {
		    width: 38%;
		    padding-bottom: 1em;
		    padding-right: 0;
		    padding-left: 2.5em;
		    min-height: 40px;
		}
		.global-footer .copyright, .global-footer-social .copyright {
		    display: block;
		    text-align: center;
		}
		.global-footer .footer-nav, .global-footer .copyright, .global-footer-social .footer-nav, .global-footer-social .copyright {
		    margin-left: 1.5em;
		    margin-right: 1.5em;
		}
		.main-box {
			padding-top: 63px;
		}
	}
	
</style>
